import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Upload,
  PopconfirmProps,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { createStudent } from "../../../store/services/signup";
import { useForm } from "antd/es/form/Form";
import img from "../../../assets/attachment.png"
import { updateStudent } from "../../../store/services/signup";

interface StudentSignupModal {
  visible: boolean;
  onCancel: (value: boolean) => void;
  fetchStudents?: () => void;
  isEdit?:boolean
  editable?:any
}
interface SignupFormValues {
  salutation: string;
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  phone: string;
  className: string;
  remember?: string;
  image: { file: File };
}

const { Option } = Select;

const salutationOptions = ["Male", "Female"];
function StudentSignupModal({
  visible,
  onCancel,
  fetchStudents,
  isEdit,
  editable,
}: StudentSignupModal) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

useEffect(() => {
  if (isEdit && editable) {
    form.setFieldsValue({
      salutation: editable?.salutation,
      firstname: editable?.name || "",
      lastname: editable?.Lastname || "",
      email: editable?.email || "",
      phone: editable?.number === "undefined" ? "" : editable?.number || "",
    });
  } else {
    form.resetFields(); // If it's not edit mode, reset the form fields
  }
}, [isEdit, editable, form]);


  const onFinish = async (values: SignupFormValues) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("salutation", values.salutation);
      formData.append("firstName", values.firstname);
      formData.append("lastName", values.lastname);
      formData.append("email", values.email);
      formData.append("password", values.password || ""); 
      values?.phone && formData.append("phoneNumber", values.phone);
      values?.image?.file && formData.append("pictures", values.image.file);
  
      if (isEdit && editable?.id) {
        formData.append("id", editable?.id); 
      }
  
      if (!isEdit) {
        const token = localStorage.getItem("token");
        if (token) {
          formData.append("token", token);
        }
      }
  
      // Use the correct API
      const res = isEdit
        ? await updateStudent(formData) 
        : await createStudent(formData); 
   
      fetchStudents && fetchStudents();
      form.resetFields();
      onCancel(false);
    } catch (error) {
      console.error("Failed to submit student data:", error);
    }
    setLoading(false);
  };
  

  return (
    <Modal open={visible} onCancel={() => onCancel(false)} footer={null}>
      <Row>
        <Col span={24}>
          <div className="modalheading">
            {isEdit ? <h1>Edit Student</h1> : <h1>Add Student</h1> }
            
          </div>
          <p>Please enter your details.</p>
          <br />
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="salutation"
              label="Gender"
              rules={[
                { required: true, message: "Please select your gender" },
              ]}
            >
              <Select
                style={{ width: "100%", borderRadius: "8px" }}
                dropdownStyle={{
                  backgroundColor: "white",
                  border: "1px solid #d9d9d9",
                }}
              >
                {salutationOptions.map((option) => (
                  <Option key={option} value={option}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="firstname"
              label="First Name"
              rules={[
                { required: true, message: "Please enter your first name" },
              ]}
            >
              <input className="input" placeholder="Enter Your First Name" />
            </Form.Item>
            <Form.Item
              name="lastname"
              label="Last Name"
              rules={[
                { required: true, message: "Please enter your last name" },
              ]}
            >
              <input className="input" placeholder="Enter Your Last Name" />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please enter a valid email",
                },
              ]}
            >
              <input className="input" placeholder="Enter your Email" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Password"
              rules={
                isEdit
                  ? [] 
                  : [{ required: true, message: "Please enter your password" }] 
              }
            >
              <input
                type="password"
                className="input"
                placeholder={isEdit ? "Enter new password (optional)" : "Enter your Password"}

              />
            </Form.Item>
            <Form.Item name="phone" label="Phone Number">
              <input className="input" placeholder="Enter your Phone Number" />
            </Form.Item>

            <Form.Item name="image" label="Upload Image">
              <Upload beforeUpload={() => false}  listType="picture">
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
            </Form.Item>
            <Space>
              <Button className="cancelbtn" onClick={() => onCancel(false)} disabled={loading}>
                Cancel
              </Button>
              <Button htmlType="submit" className="addbtn" loading={loading} disabled={loading}>
                Add
              </Button>
            </Space>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
}

export default StudentSignupModal;
